import "./index.css";

import { useEffect } from "react";
import { PasswordGate } from "@/components/PasswordGate";
import { Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { ProcessComparison } from "@/components/sections/ProcessComparison";
import { CaseStudies } from "@/components/sections/CaseStudies";
import { About } from "@/components/sections/About";
import { PeerQuotes } from "@/components/sections/PeerQuotes";
import { CV } from "@/components/sections/CV";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { CaseStudyDesignSystem } from "@/components/sections/CaseStudyDesignSystem";
import { CaseStudyQuiz } from "@/components/sections/CaseStudyQuiz";
import { CaseStudyHomelightOffers } from "@/components/sections/CaseStudyHomelightOffers";
import { CaseStudyUIExamples } from "@/components/sections/CaseStudyUIExamples";
import { CaseStudyLettering } from "@/components/sections/CaseStudyLettering";
import { CaseStudyNotification } from "@/components/sections/CaseStudyNotification";
import { CaseStudyApproval } from "@/components/sections/CaseStudyApproval";
import { CaseStudyLiveActivities } from "@/components/sections/CaseStudyLiveActivities";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

/** SVG noise grain — generated purely by the GPU, zero network cost */
const GRAIN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch"/><feColorMatrix type="saturate" values="0"/></filter><rect width="200" height="200" filter="url(#n)"/></svg>`;
const GRAIN_URI = `url("data:image/svg+xml,${encodeURIComponent(GRAIN_SVG)}")`;

/** Riso paper grain overlay — sits above all content via z-index */
function RisoOverlay() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none",
        backgroundImage: GRAIN_URI,
        backgroundRepeat: "repeat",
        backgroundSize: "200px 200px",
        mixBlendMode: "multiply",
        opacity: 0.24,
      }}
    />
  );
}

export function App() {
  return (
    <PasswordGate>
      <ScrollToTop />
      <Routes>
      <Route
        path="/"
        element={
          <div className="min-h-screen bg-[#F5F5F7]">
            <RisoOverlay />
            <Nav />
            <main>
              <Hero />
              <CaseStudies />
              {/* <ProcessComparison /> */}
              <About />
              <PeerQuotes />
              <CV />
              <Contact />
            </main>
            <Footer />
          </div>
        }
      />
      <Route path="/case-study/design-system" element={<CaseStudyDesignSystem />} />
      <Route path="/case-study/quiz" element={<CaseStudyQuiz />} />
      <Route path="/case-study/homelight-offers" element={<CaseStudyHomelightOffers />} />
      <Route path="/case-study/ui-examples" element={<CaseStudyUIExamples />} />
      <Route path="/case-study/lettering" element={<CaseStudyLettering />} />
      <Route path="/case-study/notification-wallet" element={<CaseStudyNotification />} />
      <Route path="/case-study/loan-signing" element={<CaseStudyApproval />} />
      <Route path="/case-study/live-activities" element={<CaseStudyLiveActivities />} />
    </Routes>
    </PasswordGate>
  );
}

export default App;
